<template>
    <card>
        <template slot="header">
            <h2 class="card-title">{{ title }}</h2>
        </template>
        <div class="row">
            <div class="col-md-6">
                <div class="row">
                    <div class="col-6 d-flex flex-column justify-content-center">
                        <h3>{{ $t('dashboard.general__global') }}</h3>
                        <table class="table chart-legend-table">
                            <tbody>
                                <tr>
                                    <td><strong>Drafts</strong></td>
                                    <td class="text-right">{{ data.global.drafts }}</td>
                                </tr>
                                <tr>
                                    <td><strong>Submitted</strong></td>
                                    <td class="text-right">{{ data.global.submitted }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-6">
                        <pie-chart :chart-data="statusChartData" :extra-options="chartOptions"></pie-chart>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-6 d-flex flex-column justify-content-center">
                        <table class="table chart-legend-table">
                            <tbody>
                                <tr>
                                    <td><strong>Awarded</strong></td>
                                    <td class="text-right">{{ data.global.awarded }}</td>
                                </tr>
                                <tr>
                                    <td><strong>Rejected</strong></td>
                                    <td class="text-right">{{ data.global.rejected }}</td>
                                </tr>
                                <tr>
                                    <td><strong>Cancelled</strong></td>
                                    <td class="text-right">{{ data.global.cancelled }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-6">
                        <pie-chart :chart-data="finalStatusChartData" :extra-options="chartOptions"></pie-chart>
                    </div>
                </div>
            </div>
        </div>

        <hr class="mt-5 mb-5" v-if="grantId === 5"/>

        <div class="row" v-if="grantId === 5">
            <div class="col-md-6">
                <div class="row">
                    <div class="col-6 d-flex flex-column justify-content-center">
                        <h3>{{ $t('dashboard.co_applicant') }}</h3>
                        <table class="table chart-legend-table">
                            <tbody>
                                <tr>
                                    <td><strong>With</strong></td>
                                    <td class="text-right">{{ data.with }}</td>
                                </tr>
                                <tr>
                                    <td><strong>Without</strong></td>
                                    <td class="text-right">{{ data.without }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-6">
                        <pie-chart :chart-data="languageChartData" :extra-options="chartOptions"></pie-chart>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
            </div>
        </div>

        <hr class="mt-5 mb-5" />

        <div class="row">
            <div class="col-md-6">
                <div class="row">
                    <div class="col-6 d-flex flex-column justify-content-center">
                        <h3>{{ $t('dashboard.general__language') }}</h3>
                        <table class="table chart-legend-table">
                            <tbody>
                                <tr>
                                    <td><strong>English</strong></td>
                                    <td class="text-right">{{ data.language.en }}</td>
                                </tr>
                                <tr>
                                    <td><strong>French</strong></td>
                                    <td class="text-right">{{ data.language.fr }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-6">
                        <pie-chart :chart-data="languageChartData" :extra-options="chartOptions"></pie-chart>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
            </div>
        </div>

        <!-- <hr class="mt-5 mb-5" /> -->

        <div class="row mt-5">
            <div class="col-8 d-flex flex-column justify-content-center">
                <h3>{{ $t('dashboard.general__regional') }}</h3>
                <table class="table chart-legend-table">
                    <thead>
                        <th>&nbsp;</th>
                        <td class="text-center" v-for="(region, id) in data.regional" :key="id"><b>{{ region.name }}</b></td>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Draft</td>
                            <td class="text-center" v-for="(region, id) in data.regional" :key="id">{{ region.draft }}</td>
                        </tr>
                        <tr>
                            <td>Submitted</td>
                            <td class="text-center" v-for="(region, id) in data.regional" :key="id">{{ region.submitted }}</td>
                        </tr>
                        <tr>
                            <td>Awarded</td>
                            <td class="text-center" v-for="(region, id) in data.regional" :key="id">{{ region.awarded }}</td>
                        </tr>
                        <tr>
                            <td>Rejected</td>
                            <td class="text-center" v-for="(region, id) in data.regional" :key="id">{{ region.rejected }}</td>
                        </tr>
                        <tr>
                            <td>Cancelled</td>
                            <td class="text-center" v-for="(region, id) in data.regional" :key="id">{{ region.cancelled }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-4">
                <bar-chart :chart-id="'regional-chart'" :chart-data="regionalChartData" :extra-options="chartOptions"></bar-chart>
            </div>
        </div>

        <div class="row mt-5">
            <div class="col-12">
                <base-button @click="exportExcell()" type="default" size="lg" class="btn-fill">
                    Export
                </base-button>
                <base-button @click="viewDistributionByCountry = true" type="default" size="lg" class="btn-fill pull-right">
                    View Distribution by Country
                </base-button>
            </div>
        </div>

        <popup-by-country v-if="byCountryData" :visible.sync="viewDistributionByCountry" :data="byCountryData" :data-key="'statuses'"></popup-by-country>
    </card>
</template>
<script>
import {UserRoles} from "@/services";
import PieChart from "src/components/Charts/PieChart.js";
import BarChart from "src/components/Charts/BarChart.js";

import PopupByCountry from '../Popups/PopupByCountry';

export default
{
    name: "applications-card",
    components:
    {
        PieChart,
        BarChart,
        PopupByCountry
    },
    props:
    {
        data:
        {
            type: Object,
            default: () => ({
                global: {},
                language: {},
                regional: []
            }),
        },
        byCountryData: Object,
        chartData: Object,
        items: Array,
        title: String,
        grantId: Number
    },
    data()
    {
        return {
            loggedUser: {},
            viewDistributionByCountry: false,
            chartOptions:
            {
                tooltips:
                {
                    mode: 'label',
                },
                legend:
                {
                    display: false
                },
                responsive: true
            },
        };
    },
    computed:
    {
        statusChartData: function ()
        {
            return {
                datasets:
                [
                    {
                        backgroundColor: ['#ff6384', '#ffcd56', '#36a2eb', '#8ceb36', '#6393ff', '#9863ff', '#4E0013', '#74132C', '#FF9837', '#267257', '#0E553C', '#b0b6f2', '#c8bef3', '#dbc7f3', '#ebd2f4', '#d8eb67', '#FA6ECA', '#FFFF05', '#000000', '#21BFBF', '#BF2604', '#593F36', '#6B1C8C', '#A64484'],
                        data: [this.data.global.drafts, this.data.global.submitted]
                    }
                ],
                labels: ['Drafts', 'Submitted']
            };
        },
        finalStatusChartData: function ()
        {
            return {
                datasets:
                [
                    {
                        backgroundColor: ['#ff6384', '#ffcd56', '#36a2eb', '#8ceb36', '#6393ff', '#9863ff', '#4E0013', '#74132C', '#FF9837', '#267257', '#0E553C', '#b0b6f2', '#c8bef3', '#dbc7f3', '#ebd2f4', '#d8eb67', '#FA6ECA', '#FFFF05', '#000000', '#21BFBF', '#BF2604', '#593F36', '#6B1C8C', '#A64484'],
                        data: [this.data.global.awarded, this.data.global.rejected,  this.data.global.cancelled]
                    }
                ],
                labels: ['Awarded', 'Rejected', 'Cancelled']
            };
        },
        languageChartData: function ()
        {
            return {
                datasets:
                [
                    {
                        backgroundColor: ['#ff6384', '#ffcd56', '#36a2eb', '#8ceb36', '#6393ff', '#9863ff', '#4E0013', '#74132C', '#FF9837', '#267257', '#0E553C', '#b0b6f2', '#c8bef3', '#dbc7f3', '#ebd2f4', '#d8eb67', '#FA6ECA', '#FFFF05', '#000000', '#21BFBF', '#BF2604', '#593F36', '#6B1C8C', '#A64484'],
                        data: [this.data.language.en, this.data.language.fr]
                    }
                ],
                labels: ['English', 'French']
            };
        },
        regionalChartData: function (status)
        {
            const vm = this;
            let labels = [];
            let data = [];

            let draft = [];
            let submitted = [];
            let awarded = [];
            let rejected = [];
            let cancelled = [];

            if (vm.data.regional)
            {
                for (let key in vm.data.regional)
                {
                    const region = vm.data.regional[key];

                    labels.push(region.name);
                    draft.push(region.draft);
                    submitted.push(region.submitted);
                    awarded.push(region.awarded);
                    rejected.push(region.rejected);
                    cancelled.push(region.cancelled);
                }
            }

            return {
                datasets:
                [
                    {
                        label: 'Draft',
                        backgroundColor: '#ff6384',
                        data: draft
                    },
                    {
                        label: 'Submitted',
                        backgroundColor: '#ffcd56',
                        data: submitted
                    },
                    {
                        label: 'Awarded',
                        backgroundColor: '#36a2eb',
                        data: awarded
                    },
                    {
                        label: 'Rejected',
                        backgroundColor: '#8ceb36',
                        data: rejected
                    },
                    {
                        label: 'Cancelled',
                        backgroundColor: '#6393ff',
                        data: cancelled
                    },
                ],
                labels: labels
            };
        }
    },
    beforeMount()
    {
        this.loggedUser = this.$store.getters['Auth/loggedUser'];
    },
    mounted()
    {
        const vm = this;

        // console.log(vm.data.regional.map((item) => item.name));

        // vm.statusChartData

        // [vm.data.global.drafts, vm.data.global.submitted];
        // [vm.data.global.awarded, vm.data.global.rejected]
    },
    methods:
    {
        exportExcell()
        {
            const vm = this;

            if (vm.loggedUser && vm.loggedUser.role === UserRoles.REGIONAL_ADMIN)
            {
                window.location = process.env.VUE_APP_ROOT_API + '/dashboard/export?grant_id=' + vm.grantId + '&regions=' + vm.loggedUser.regionIds.join(',');
            }
            else
            {
                window.location = process.env.VUE_APP_ROOT_API + '/dashboard/export?grant_id=' + vm.grantId;
            }
        }
    }
};
</script>
<style lang="scss">
    .bpf-chart-holder
    {
        display: flex;
        justify-content: center;
    }

    #pie-chart
    {
        /* width: 80% !important;
        height: auto !important; */
        margin: auto;
    }

    #bar-chart
    {
        /* height: 300px !important; */
    }

    .chart-legend-table tbody tr
    {
        td:first-child
        {
            position: relative;
            padding-left: 37px;
        }

        td:first-child:before
        {
            content: '';
            // position: relative;
            // top: 4px;
            position: absolute;
            top: 12px;
            left: 7px;
            // position: absolute;
            // top: 0;
            display: inline-block;
            width: 20px;
            height: 20px;
            margin-right: 10px;

            background-color: #ff6384;
        }

        &:nth-child(2) td:first-child:before { background-color: #ffcd56; }
        &:nth-child(3) td:first-child:before { background-color: #36a2eb; }
        &:nth-child(4) td:first-child:before { background-color: #8ceb36; }
        &:nth-child(5) td:first-child:before { background-color: #6393ff; }
        &:nth-child(6) td:first-child:before { background-color: #9863ff; }
        &:nth-child(7) td:first-child:before { background-color: #4E0013; }
        &:nth-child(8) td:first-child:before { background-color: #74132C; }
        &:nth-child(9) td:first-child:before { background-color: #FF9837; }
        &:nth-child(10) td:first-child:before { background-color: #267257; }
        &:nth-child(11) td:first-child:before { background-color: #0E553C; }
        &:nth-child(12) td:first-child:before { background-color: #b0b6f2; }
        &:nth-child(13) td:first-child:before { background-color: #c8bef3; }
        &:nth-child(14) td:first-child:before { background-color: #dbc7f3; }
        &:nth-child(15) td:first-child:before { background-color: #ebd2f4; }
        &:nth-child(16) td:first-child:before { background-color:  #d8eb67; }
        &:nth-child(17) td:first-child:before { background-color:  #FA6ECA; }
        &:nth-child(18) td:first-child:before { background-color:  #FFFF05; }
        &:nth-child(19) td:first-child:before { background-color:  #000000; }
        &:nth-child(20) td:first-child:before { background-color:  #21BFBF; }
        &:nth-child(21) td:first-child:before { background-color:  #BF2604; }
        &:nth-child(22) td:first-child:before { background-color:  #593F36; }
        &:nth-child(23) td:first-child:before { background-color:  #6B1C8C; }
        &:nth-child(24) td:first-child:before { background-color:  #A64484; }

        // ['#ff6384', '#ffcd56', '#36a2eb', '#8ceb36', '#6393ff', '#9863ff', '#4E0013', '#74132C', '#003925', '#267257', '#0E553C', '#b0b6f2', '#c8bef3', '#dbc7f3', '#ebd2f4', '#d8eb67'],
    }

    /* ['#4E0013', '#74132C', '#003925', '#267257', '#0E553C', '#b0b6f2', '#c8bef3', '#dbc7f3', '#ebd2f4'] */
</style>
